const routes = [
    {
        path: '/link/rule',
        name: 'linkRule',
        component: () => import('@src/modules/linkage/view/linkage'),
        meta: {
            requireAuth: false,
            routerAlive: true
        }
    }, {
        path: '/link/record',
        name: 'linkRecord',
        component: () => import('@src/modules/linkage/view/linkRecord'),
        meta: {
            requireAuth: false,
            routerAlive: true
        }
    }
]

export default routes
